require('./editAddon.scss');
const controller = require('./editAddonCtrl').default;
const template = require('./editAddon.html');

const deps = [
  require('ui/bk/angularMaterial').name,
  require('ui/bk/monthYearSelect').name,
  require('data/model/ledger').name,
  require('data/model/addon').name,
  require('data/user').name,
  require('data/model/clientSettings').name,
];

module.exports = angular.module('bench.ui.editAddon', deps).component('blEditAddon', {
  bindings: {
    addonId: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
});
